import {
    STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION,
    COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES,
    COMPLIANCE_DECLARATION,
    SUPPORTING_DOCUMENTS,
    CALL_BACK_CALL_RE_ORIGINATION_SERVICES_NON_PREPAID,
    INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID,
    STORE_AND_RETRIEVE_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID,
    STORE_AND_FORWARD_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID,
    INTERNATIONAL_CALLING_CARD_SERVICES_NON_PREPAID,
    AUDIOTEX_SERVICE,
    RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES,
    PUBLIC_CHAIN_PAYPHONE_SERVICES_NON_PREPAID_OPTIONAL,
} from 'common/application.const/Licence/MyApplication/SBOCApplication';
import {
    SBOC_INFORMATION
} from 'common/application.const/Licence/MyApplication/amend-SBOCApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';


const cancelLicence = (licenceDetails: any, application: string, docsLic: any) => {
    return {
        id: 'cancel-licence-details',
        formID: 'cancel-licence-details',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
            [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
            [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

            [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
            [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

            [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: docsLic ? docsLic : '-'
        }
    };
};

const renewLicence = (licenceDetails: any, application: string) => {
    return {
        id: 'renew-licence-details',
        formID: 'renew-licence-details',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
            [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
            [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

            [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
            [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
            [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
            [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
            [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
            [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
        }
    };
};

const amendLicence = (licenceDetails: any, application: string, docsLic: any) => {

    const mapped = (
        licenceDetails?.iwantToAmend ||
        licenceDetails?.licenceDetails?.iwantToAmend ||
        licenceDetails?.iWantToUpdate ||
        licenceDetails?.licenceDetails?.iWantToUpdate ||
        licenceDetails?.amendments?.iWantTo
    )?.map((data: { [key: string]: string }) => {
        return {
            type: data.mixedValue
        };
    });

    return {
        id: 'amend-services-based-operations-class-licence',
        formID: 'amend-services-based-operations-class-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${SBOC_INFORMATION}-amend-table`]: [...mapped],

            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-required-information-will-be-attached`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.requiredInformationWillBeAttached ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-question-one`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.question1 ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-if-yes-question-one`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.ifYesForQuestion1PleaseProvideDetails ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-question-two`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.question2 ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-if-yes-question-two`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.ifYesForQuestion2PleaseProvideDetails ?? '-',

            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-have-you-commenced-provision-operation-of-any-of-the-telecommunication-services-applied-for-in-this-application`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices
                    ?.provisioningOperationOfAnyOfTheTelecommunicationServices ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-please-state-the-date-of-commencement`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.pleaseStateTheDateOfCommencement ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-number-of-users`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.numberOfUsers ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-profile-of-users`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.profileOfUsers ?? '-',

            [`${COMPLIANCE_DECLARATION}-declaration-1`]: licenceDetails?.ComplianceDeclaration?.Declaration1 === "true" ? 'Yes' : 'No',
            [`${COMPLIANCE_DECLARATION}-declaration-2`]: licenceDetails?.ComplianceDeclaration?.Declaration2 === "true" ? 'Yes' : 'No',
            [`${COMPLIANCE_DECLARATION}-declaration-3`]: licenceDetails?.ComplianceDeclaration?.Declaration3 === "true" ? 'Yes' : 'No',
            [`${COMPLIANCE_DECLARATION}-declaration-4`]: licenceDetails?.ComplianceDeclaration?.Declaration4 === "true" ? 'Yes' : 'No',
            [`${COMPLIANCE_DECLARATION}-declaration-5`]: licenceDetails?.ComplianceDeclaration?.Declaration5 === "true" ? 'Yes' : 'No',


            [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: docsLic ? docsLic : undefined
        }
    };
};

export const formatSBOCApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'services-based-operations-class-licence',
        formID: 'services-based-operations-class-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {

            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-required-information-will-be-attached`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.requiredInformationWillBeAttached ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-question-one`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.question1 ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-if-yes-question-one`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.ifYesForQuestion1PleaseProvideDetails ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-question-two`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.question2 ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-if-yes-question-two`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.ifYesForQuestion2PleaseProvideDetails ?? '-',
                

            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-have-you-commenced-provision-operation-of-any-of-the-telecommunication-services-applied-for-in-this-application`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices
                    ?.provisioningOperationOfAnyOfTheTelecommunicationServices ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-please-state-the-date-of-commencement`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.pleaseStateTheDateOfCommencement ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-number-of-users`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.numberOfUsers ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-profile-of-users`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.profileOfUsers ?? '-',

            [`${COMPLIANCE_DECLARATION}-declaration-1`]: licenceDetails?.ComplianceDeclaration?.Declaration1 === "true" ? 'Yes' : 'No',
            [`${COMPLIANCE_DECLARATION}-declaration-2`]: licenceDetails?.ComplianceDeclaration?.Declaration2 === "true" ? 'Yes' : 'No',
            [`${COMPLIANCE_DECLARATION}-declaration-3`]: licenceDetails?.ComplianceDeclaration?.Declaration3 === "true" ? 'Yes' : 'No',
            [`${COMPLIANCE_DECLARATION}-declaration-4`]: licenceDetails?.ComplianceDeclaration?.Declaration4 === "true" ? 'Yes' : 'No',
            [`${COMPLIANCE_DECLARATION}-declaration-5`]: licenceDetails?.ComplianceDeclaration?.Declaration5 === "true" ? 'Yes' : 'No',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = cancelLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication', docsLic);
    }

    if (transactionType === 'Renew') {
        licence = renewLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication');
    }

    if (transactionType === 'Amend') {
        licence = amendLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication', docsLic);
    }

    return licence;
};

export const formatSBOCServices = async (licenceDetails: any) => {
    return {
        id: 'sboc-services',
        formID: 'sboc-services',
        hasError: true,
        title: 'Services',
        values: {
            [`${CALL_BACK_CALL_RE_ORIGINATION_SERVICES_NON_PREPAID}-call-back`]: licenceDetails?.OperationsServiceRegistration?.CallbackReoriginationServices === "true" ? 'Non Prepaid' : '-',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID}-internet-based`]: licenceDetails?.OperationsServiceRegistration?.InternetBasedVoiceDataServices === "true" ? 'Non Prepaid' : 'No',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID}-declaration-1`]: licenceDetails?.OperationsServiceRegistration?.Declaration1InternetBasedVoiceDataServices === "true" ? 'Yes' : 'No',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID}-declaration-2`]: licenceDetails?.OperationsServiceRegistration?.Declaration2InternetBasedVoiceDataServices === "true" ? 'Yes' : 'No',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID}-declaration-3`]: licenceDetails?.OperationsServiceRegistration?.Declaration3InternetBasedVoiceDataServices === "true" ? 'Yes' : 'No',
            [`${STORE_AND_RETRIEVE_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID}-store-and-retrieve`]: licenceDetails?.OperationsServiceRegistration?.StoreAndRetrieveValueAddedNetworkServices === "true" ? 'Non Prepaid' : '-',
            [`${STORE_AND_RETRIEVE_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID}-leased-circuits`]: licenceDetails?.OperationsServiceRegistration?.IsUsingLeasedCircuitsConnections ?? '-',
            [`${STORE_AND_RETRIEVE_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID}-providing-premium`]: licenceDetails?.OperationsServiceRegistration?.IsProvidingPremiumRateServices ?? '-',
            [`${STORE_AND_RETRIEVE_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID}-able-to-comply`]: licenceDetails?.OperationsServiceRegistration?.AbleToComplyWithCodeOfPractice === "true" ? 'Yes' : 'No',
            [`${STORE_AND_FORWARD_VALUE_ADDED_NETWORK_SERVICES_NON_PREPAID}-store-and-forward`]: licenceDetails?.OperationsServiceRegistration?.StoreAndForwardValueAddedNetworkServices === "true" ? 'Non Prepaid' : '-',
            [`${INTERNATIONAL_CALLING_CARD_SERVICES_NON_PREPAID}-international-calling-card`]: licenceDetails?.OperationsServiceRegistration?.InternationalCallingCardServices === "true" ? 'Non Prepaid' : '-',
            [`${AUDIOTEX_SERVICE}-audiotex-service`]: Array.isArray(licenceDetails?.OperationsServiceRegistration?.AudiotexService) && licenceDetails.OperationsServiceRegistration.AudiotexService.length > 0 ? licenceDetails.OperationsServiceRegistration.AudiotexService.filter((item:any) => item.pySelected === "true").map((item:any) => item.mixedValue).join('\n') : '-',
            [`${AUDIOTEX_SERVICE}-other-audiotex-service`]:  licenceDetails?.OperationsServiceRegistration?.OtherAudioTextService ?? '-',
            [`${AUDIOTEX_SERVICE}-required-information-audiotex`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.RequiredInfoOfAudiotexServices ?? '-',
            [`${AUDIOTEX_SERVICE}-audiotex-services-offered`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.AttachedOfferedAndDetailsOnTheCharges ?? '-',
            [`${AUDIOTEX_SERVICE}-required-information-of-scope`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.RequiredInfoOfScopeOfProgrammes ?? '-',
            [`${AUDIOTEX_SERVICE}-scope-and-types-of-programmes`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.ScopeOfProgrammesByEachAudiotexServices ?? '-',
            [`${AUDIOTEX_SERVICE}-confirm-audiotex-1900`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.Audiotex1900AccessLineConfirmation ?? '-',
            [`${AUDIOTEX_SERVICE}-current-call-charge`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.CallChargeAnnouncedAtBeginningOfEachCall ?? '-',
            [`${AUDIOTEX_SERVICE}-enable-callers`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.AudiotexServicesNoRealTimeCallerCommunication ?? '-',
            [`${AUDIOTEX_SERVICE}-live-programmes`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.AudiotexServicesNoLiveProgrammes ?? '-',
            [`${AUDIOTEX_SERVICE}-no-delay`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.NoDelayInStartingAnnouncementOrProgramme ?? '-',
            [`${AUDIOTEX_SERVICE}-each-audiotex`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.EachAudiotexAssignedDifferentTelephoneNo ?? '-',
            [`${AUDIOTEX_SERVICE}-no-interruption`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.NoInterruptionDuringAnnouncementOrProgramme ?? '-',
            [`${AUDIOTEX_SERVICE}-each-call-period`]:  licenceDetails?.OperationsServiceRegistration?.Annex?.EachCallMax10MinWithExtensionOption ?? '-',
            [`${RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-resale-of-public-switched-telecommunication-services`]:  Array.isArray(licenceDetails?.PublicSwitchedTelecommunicationServices) && licenceDetails.PublicSwitchedTelecommunicationServices.length > 0 ? licenceDetails.PublicSwitchedTelecommunicationServices.map((item:any) => item.mixedValue).join('\n') : '-',
            [`${RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-others-of-public-switched-telecommunication-services`]:  licenceDetails?.OperationsServiceRegistration?.OthersOfPublicSwitchedTelecommunicationServices ?? '-',
            [`${RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-required-information-will-be-attached`]:  licenceDetails?.OperationsServiceRegistration?.requiredInformationWillBeAttached ?? '-',
            [`${PUBLIC_CHAIN_PAYPHONE_SERVICES_NON_PREPAID_OPTIONAL}-public-chain-payphone-services`]:  licenceDetails?.OperationsServiceRegistration?.PublicChainPayPhoneServices === "true" ? 'Non Prepaid' : '-',
        }
    };
};

const sbocPayloadApplication = {
    formatSBOCApplication,
    formatSBOCServices
};

export default sbocPayloadApplication;
